<template>
    <div
        ref="element"
        v-element-visibility="onElementVisibility"
        class="transition-all duration-1000 ease-in-out"
        :class="[animationDefaultClasses, {
            [animationTriggerClasses]: isVisible,
        }]"
        :style="{
            'transition-delay': `${((animationOffset + 1) * 125) + 150}ms`,
        }"
    >
        <slot />
    </div>
</template>

<script setup>
    import { vElementVisibility } from '@vueuse/components'

    // const pageType = inject('page-type', 'home')

    const props = defineProps({
        animationType: String,
        animationOffset: {
            type: Number,
            default: 0
        }
    })

    const { digistormSettings } = storeToRefs(useSiteStore())

    const isPremier = computed(() => {
        return digistormSettings.value?.websiteTier === 'premier'
    })

    const element = ref(null)

    const animationGlobal = ref(digistormSettings.value?.animationGlobal)

    // Create a computed property for the final animation type
    const computedAnimationType = computed(() => {
        return props.animationType || animationGlobal.value || 'fade-in'
    })

    // The initial state is hidden on Premier blocks
    const isVisible = ref(!isPremier.value || computedAnimationType.value === 'none')

    
    const animationDefaultClasses = computed(() => {
        switch (computedAnimationType.value) {
            case 'fade-in':
            default:
                return 'opacity-0'
            case 'fade-in-up':
                return 'opacity-0 translate-y-40'
            case 'slide-in-right':
                return 'opacity-0 translate-x-1/2'
            case 'scale-in':
                return 'opacity-0 scale-[.9]'
            case 'none':
                return 'opacity-100'
        }
    })

    const animationTriggerClasses = computed(() => {
        switch (computedAnimationType.value) {
            case 'fade-in':
            default:
                return '!opacity-100'
            case 'fade-in-up':
                return '!opacity-100 !translate-y-0'
            case 'slide-in-right':
                return '!opacity-100 !translate-x-0'
            case 'scale-in':
                return '!opacity-100 !scale-100'
        }
    })

    const onElementVisibility = (state) => {
        if (!state) {
            return
        }

        // once the element is visible then its always visible
        isVisible.value = state
    }


</script>

<style lang="scss" scoped>

</style>